export default class Region {
  constructor(id, name, coordinates, dateCreatedUtc, dateModifiedUtc) {
    this.id = id;
    this.name = name;
    this.coordinates = coordinates;
    this.dateCreatedUtc = dateCreatedUtc;
    this.dateModifiedUtc = dateModifiedUtc;
  }
}
